// extracted by mini-css-extract-plugin
export var black = "_2i-6";
export var brand = "_2i-1";
export var ddefault = "_2i-0";
export var error = "_2i-3";
export var gray = "_2i-2";
export var highContrast = "_2i-8";
export var outline = "_2i-7";
export var success = "_2i-5";
export var warning = "_2i-4";